import "./PaymentMethods.css";

import { CardElement, injectStripe } from "react-stripe-elements";

import Api from "../services/api";
import AuthService from "../services/auth";
import React from "react";
import { compose } from "recompose";
import { withRouter } from "react-router-dom";

class SubscriptionForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: ""
    };
  }

  handleSubmit(ev) {
    const { stripe, ucdUser, showOverlay } = this.props;

    showOverlay();
    // We don't want to let default form submission happen here, which would refresh the page.
    ev.preventDefault();

    // Within the context of `Elements`, this call to createToken knows which Element to
    // tokenize, since there's only one in this group.
    stripe
      .createSource({
        type: "card",
        currency: "usd",
        owner: {
          name: `${ucdUser.firstName} ${ucdUser.lastName}`
        }
      })
      .then(({ source }) => {
        new Api()
          .post(
            "/payment/start-subscription",
            {
              source: source.id
            },
            AuthService.getAuthCookie()
          )
          .then(response => {
            if (response.result.status === "active") {
              showOverlay(false);
            }
            if (response.redirect) {
              this.props.history.push(response.redirect);
            }
          })
          .catch(error => {
            this.setState(
              {
                errorMessage: "Credit card declined"
              },
              () => {
                showOverlay(false);
              }
            );
          });
      });

    // However, this line of code will do the same thing:
    // this.props.stripe.createToken({type: 'card', name: 'Jenny Rosen'});
  }

  resetErrorMessage() {
    this.setState({
      errorMessage: ""
    });
  }

  render() {
    const { errorMessage } = this.state;
    return (
      <div className="methods body">
        <div className="col col-12">
          <div className="method-form-container">
            {errorMessage.length > 0 && (
              <div className="intro mt-0">
                <p className="bold">{errorMessage}</p>
                <p>TRY AGAIN , OR WITH ANOTHER CREDIT CARD</p>
                <button
                  onClick={this.resetErrorMessage.bind(this)}
                  className="try-again-button mt-5"
                >
                  Try again
                </button>
              </div>
            )}
            {errorMessage.length === 0 && (
              <form onSubmit={e => this.handleSubmit(e)}>
                <label className={"stripe-label"}>
                  Card details
                  <CardElement onReady={el => el.focus()} />
                </label>
                <button className="method-form__button">Subscribe</button>
              </form>
            )}
          </div>
        </div>
        <p>
          *Our{" "}
          <a
            href="https://upperclassdates.com/terms"
            target="_blank"
            rel="noopener noreferrer"
          >
            terms and conditions
          </a>{" "}
          are applicable on this subscription.
        </p>
      </div>
    );
  }
}

export default compose(
  injectStripe,
  withRouter
)(SubscriptionForm);



// WEBPACK FOOTER //
// ./src/components/SubscriptionForm.js